// extracted by mini-css-extract-plugin
export default {"cont":"GraphRecord_cont__x51ZU","logo":"GraphRecord_logo__kQR-o","time":"GraphRecord_time__aCVFn"};